import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Divider, notification, Select } from 'antd';
import CustomerActions from '@Actions/customerActions';
import './style.scss';
import ArrayHelpers from '@Helpers/ArrayHelpers';
import Helpers from '@Apis/helpers';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
function SelectCustomer({
  getCustomers, user, tenantId, showAddCustomer, customers, onChange, selectedCustomer, maxTagCount,
  disabled, showError, getPopupContainer, hideCustomersLinkedToVendors, title, hideTitle, hideCity,
  containerClass, inputClassName, labelClassName, addCustomer, isMultiple, allowClear, getCustomersLoading,
  noDropdownAlign, customStyle, excludeCustomerIds, required, bordered,
}) {
  const [isUserReady, setIsUserReady] = useState(false);
  const [data, setData] = useState([]);
  const [lastCustomerList, setLastCustomerList] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    setLastCustomerList(customers?.customers);
  }, [customers]);

  useEffect(() => {
    const isTenantIdValid = isMultiple ? tenantId?.length > 0 : (tenantId || user?.tenant_info?.tenant_id);

    if (isTenantIdValid && !isUserReady) {
      const tenantToUse = tenantId || user?.tenant_info?.tenant_id;
      const selectedCustomers = Array.isArray(selectedCustomer) ? selectedCustomer.join(',') : selectedCustomer;

      getCustomers('', tenantToUse, 1, 50, null, () => { }, '', selectedCustomers, excludeCustomerIds);
      setIsUserReady(true);
    }
  }, [tenantId, selectedCustomer, isMultiple]);

  const permissionForCreateCustomer = Helpers.getPermission(
    Helpers.permissionEntities.CUSTOMER,
    Helpers.permissionTypes.CREATE,
    user,
  );

  return (
    <div
      className={
        `${containerClass} select-customer__wrapper`
      }
    >
      {!hideTitle ? (
        <div className={labelClassName || 'orgFormLabel'}>
          {title || 'Customer'}
          {required && <span style={{ color: 'red' }}>{'  *'}</span>}
        </div>
      )
        : <Fragment />}
      {/* (<Select
        onDropdownVisibleChange={(open) => {
          setDropdownOpen(open); // Correctly update state
        }}
        mode={isMultiple ? 'multiple' : ''}
        value={(customers?.customers && lastCustomerList) ? selectedCustomer : undefined}
        filterOption={false}
        disabled={disabled}
        placeholder="Select customer.."
        maxTagCount={maxTagCount}
        onChange={(value) => {
          if (isMultiple) {
            const customerArr = [];
            for (let i = 0; i < value?.length; i++) {
              customerArr.push(value[i]);
            }
            onChange(customerArr);
          } else {
            onChange(
              customers?.customers.filter(
                (customer) => customer?.customer_id === value,
              )[0],
            );
          }
        }}
        // style={customStyle ?? {
        //   border: '1px solid rgba(68, 130, 218, 0.25)',
        //   borderRadius: '4px',
        //   padding: '0px',
        //   height: '32px',
        // }}
        className={inputClassName}
        bordered={bordered ? bordered : false}
        showSearch
        allowClear={allowClear}
        getPopupContainer={getPopupContainer}
        onSelect={() => {
          getCustomers(
            '',
            tenantId || user?.tenant_info?.tenant_id,
            1,
            50, '',
            () => { }, '', Array.isArray(selectedCustomer) ? selectedCustomer?.join(',') : selectedCustomer, excludeCustomerIds
          );
        }}
        onSearch={(value) => {
          getCustomers(
            value,
            tenantId || user?.tenant_info?.tenant_id,
            1,
            50, null, (cData) => {
              setData([...data, ...cData?.customers]);
            }, '', Array.isArray(selectedCustomer) ? selectedCustomer?.join(',') : selectedCustomer, excludeCustomerIds
          );
        }}
        loading={getCustomersLoading}
        dropdownRender={
          showAddCustomer
            ? (menu) => (
              <React.Fragment>
                {menu}
                <Divider style={{ margin: '0px' }} />
                <div
                  className="add__customer"
                  onClick={() => {
                    if (permissionForCreateCustomer) {
                      addCustomer();
                    } else {
                      notification.error({
                        message: 'You do not have permission to create a new customer.',
                        duration: 4,
                        placement: 'top',
                      });
                    }
                  }}
                >
                  + Add Customer
                </div>
              </React.Fragment>
            )
            : false
        }
      >
        {customers
          && customers.customers
          && ArrayHelpers.removeDuplicateCustomers(customers?.customers, 'customer_id')?.filter((item) => (hideCustomersLinkedToVendors ? (!item?.customer_info?.seller_info?.seller_id) : true)).map((item) => (
            <Option key={item.customer_id} value={item.customer_id}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div>
                  <span className="customer-code">
                    {item?.customer_info?.internal_cust_code}
                  </span>
                  <span className="separator"> - </span>
                  <span className="customer-name">
                    {item?.customer_info?.customer_name}
                  </span>
                  {item?.customer_info?.billing_address_details?.city && !hideCity && (
                    <span className="city-info">
                      (
                      {item.customer_info.billing_address_details.city}
                      )
                    </span>
                  )}
                </div>
                {/* {item?.currency_info?.currency_code && (
                  <span
                    className="qr__status "
                    style={{
                      backgroundColor: 'rgb(28, 123, 225)',
                      fontSize: '8px',
                      padding: '2px 5px',
                      height: '18px',
                      display: dropdownOpen ? 'block' : 'none',
                    }}
                  >
                    {`${item.currency_info.currency_code} (${item.currency_info.currency_symbol})`}
                  </span>
                )} */}
              {/* </div> */}
            {/* </Option> */}
          {/* ))} */}
      {/* </Select>) */}
      <PRZSelect
        onDropdownVisibleChange={(open) => {
          setDropdownOpen(open); // Correctly update state
        }}
        mode={isMultiple ? 'multiple' : ''}
        value={(customers?.customers && lastCustomerList) ? selectedCustomer : undefined}
        filterOption={false}
        disabled={disabled}
        placeholder="Select customer.."
        maxTagCount={maxTagCount}
        onChange={(value) => {
          if (isMultiple) {
            const customerArr = [];
            for (let i = 0; i < value?.length; i++) {
              customerArr.push(value[i]);
            }
            onChange(customerArr);
          } else {
            onChange(
              customers?.customers.filter(
                (customer) => customer?.customer_id === value,
              )[0],
            );
          }
        }}
        className={inputClassName}
        bordered={bordered || true}
        showSearch
        allowClear={allowClear}
        getPopupContainer={getPopupContainer}
        onSelect={() => {
          getCustomers(
            '',
            tenantId || user?.tenant_info?.tenant_id,
            1,
            50, '',
            () => { }, '', Array.isArray(selectedCustomer) ? selectedCustomer?.join(',') : selectedCustomer, excludeCustomerIds
          );
        }}
        onSearch={(value) => {
          getCustomers(
            value,
            tenantId || user?.tenant_info?.tenant_id,
            1,
            50, null, (cData) => {
              setData([...data, ...cData?.customers]);
            }, '', Array.isArray(selectedCustomer) ? selectedCustomer?.join(',') : selectedCustomer, excludeCustomerIds
          );
        }}
        loading={getCustomersLoading}
        dropdownRender={
          showAddCustomer
            ? (menu) => (
              <React.Fragment>
                {menu}
                <Divider style={{ margin: '0px' }} />
                <div
                  className="add__customer"
                  onClick={() => {
                    if (permissionForCreateCustomer) {
                      addCustomer();
                    } else {
                      notification.error({
                        message: 'You do not have permission to create a new customer.',
                        duration: 4,
                        placement: 'top',
                      });
                    }
                  }}
                >
                  + Add Customer
                </div>
              </React.Fragment>
            )
            : false
        }
      >
        {customers
          && customers.customers
          && ArrayHelpers.removeDuplicateCustomers(customers?.customers, 'customer_id')?.filter((item) => (hideCustomersLinkedToVendors ? (!item?.customer_info?.seller_info?.seller_id) : true)).map((item) => (
            <Option key={item.customer_id} value={item.customer_id}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div>
                  <span className="customer-code">
                    {item?.customer_info?.internal_cust_code}
                  </span>
                  <span className="separator"> - </span>
                  <span className="customer-name">
                    {item?.customer_info?.customer_name}
                  </span>
                  {item?.customer_info?.billing_address_details?.city && !hideCity && (
                    <span className="city-info">
                      (
                      {item.customer_info.billing_address_details.city}
                      )
                    </span>
                  )}
                </div>
              </div>
            </Option>
          ))}
      </PRZSelect>
      {showError && <div className="input-error">Please select a customer*</div>}
    </div>
  );
}

const mapStateToProps = ({ CustomerReducers, UserReducers }) => ({
  getCustomersLoading: CustomerReducers.getCustomersLoading,
  customers: CustomerReducers.customers,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomers: (keyword, tenantId, page, limit, customerId, callback, accManagerIds, selectedCustomerIds, excludeCustomerIds) => dispatch(
    CustomerActions.getCustomers(keyword, tenantId, page, limit, customerId, callback, accManagerIds, selectedCustomerIds, excludeCustomerIds),
  ),
});

SelectCustomer.propTypes = {
  user: PropTypes.any,
  customers: PropTypes.any,
  selectedCustomer: PropTypes.any,
  getCustomers: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClass: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  tenantId: PropTypes.any,
  showAddCustomer: PropTypes.bool,
  getPopupContainer: PropTypes.any,
  hideCustomersLinkedToVendors: PropTypes.any,
  addCustomer: PropTypes.any,
  isMultiple: PropTypes.any,
  allowClear: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SelectCustomer));
